import React, { useEffect, useState } from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import HeaderSection from '../components/preferences/HeaderSection';
import FiltersSection from '../components/preferences/FiltersSection';
import HeatmapMatrix from '../components/preferences/HeatmapMatrix';
import LegendChips from '../components/preferences/LegendChips';
import Recommendations from '../components/preferences/Recommendations';
import RecentlySubmitted from '../components/preferences/RecentlySubmitted';
import axios from 'axios';

const generateDummyData = () => {
    const cities = ['Los Angeles', 'Houston', 'Chicago', 'Atlanta', 'Phoenix'];
    const days = ['Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'];
    const times = [
        { label: 'Morning', start: 6, end: 9 },
        { label: 'Midday', start: 10, end: 12 },
        { label: 'Afternoon', start: 13, end: 16 },
        { label: 'Evening', start: 17, end: 20 },
        { label: 'Night', start: 21, end: 23 },
    ];
    const matrix = {};
    cities.forEach((city) => {
        matrix[city] = {};
        days.forEach((day) => {
            times.forEach(({ label }) => {
                matrix[city][`${day}-${label}`] = Math.floor(Math.random() * 40);
            });
        });
    });
    return matrix;
};

const PreferencesPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [country, setCountry] = useState('USA');
    const [county, setCounty] = useState('Los Angeles County');
    const [city, setCity] = useState('Los Angeles');
    const [sport, setSport] = useState('Basketball');
    const [age, setAge] = useState('12-14');
    const [gender, setGender] = useState('All');
    const [dataMatrix, setDataMatrix] = useState({});
    const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

    useEffect(() => {
        const fetchMatrix = async () => {
            try {
                const res = await axios.get('https://api.admin.marsreel.com/api/preferences/matrix');
                setDataMatrix(res.data || {});
            } catch (err) {
                console.error('Failed to fetch matrix data:', err);
            }
        };
        fetchMatrix();
    }, []);

    const dummyMatrix = generateDummyData();
    const voteThreshold = 23;
    const sessionRecommendations = Object.entries(dummyMatrix[city] || {}).filter(
        ([_, count]) => count >= voteThreshold
    );

    const filters = [
        { label: 'Country', value: country, set: setCountry, options: ['USA', 'Canada'] },
        { label: 'County', value: county, set: setCounty, options: ['Los Angeles County', 'Harris County'] },
        { label: 'City', value: city, set: setCity, options: ['Los Angeles', 'Houston'] },
        { label: 'Sport', value: sport, set: setSport, options: ['Basketball', 'Soccer'] },
        { label: 'Age', value: age, set: setAge, options: ['8-11', '12-14', '15-17'] },
        { label: 'Gender', value: gender, set: setGender, options: ['All', 'Male', 'Female'] },
    ];

    const intensityColor = (count) => {
        if (count === 0) return '#1f1f1f';
        if (count < 5) return '#285f54';
        if (count < 10) return '#1f7d6b';
        if (count < 15) return '#1aa27e';
        if (count < 20) return '#12c099';
        return '#29f0b5';
    };

    return (
        <Box sx={{ color: '#fff' }}>
            <Container maxWidth={isMobile ? 'sm' : 'xl'} disableGutters>
                <HeaderSection />
                <FiltersSection filters={filters} />
                <Box id="heatmap-section" sx={{ overflowX: 'auto' }}>
                    <HeatmapMatrix city={city} dataMatrix={dataMatrix} timezone={timezone} intensityColor={intensityColor} />
                    <LegendChips />
                </Box>
                <RecentlySubmitted />
                <Recommendations city={city} recommendations={sessionRecommendations} intensityColor={intensityColor} />
            </Container>
        </Box>
    );
};

export default PreferencesPage;
